import { Link } from "react-router-dom";
import { FaHome, FaHammer, FaPhone } from "react-icons/fa";
import logo from "../../assets/images/mtb-logo.jpg";
import "./navbarStyle.css";

const Navbar = () => {
  const handleCall = () => {
    window.location.href = "tel:8015501123";
  };

  return (
    <>
      <div className="nav">
        <a className="nav-topbar" href="tel:8015501123">
          <FaPhone size={10} />
          <span>Call Us Today &nbsp;|&nbsp; 801-550-1123</span>
        </a>
        <div className="container-1200 row-space-between">
          <Link to="/">
            <img className="nav-img" src={logo} alt="Logo" />
          </Link>
          <div className="row">
            <Link className="nav-link" to="/">
              <FaHome size={24} />
            </Link>
            <Link className="nav-link" to="/projects">
              <FaHammer size={24} />
            </Link>
            <div className="nav-phone" onClick={handleCall}>
              <FaPhone size={20} className="nav-phone-icon" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
